import { Button, Flex } from '@mantine/core';

import { STATUS_ACTIONS } from '../../config';
import {
  useFundingStep,
  useInvalidateSimulationStatus,
  useSandboxUiContext,
  useSimulationFormContext,
  useSimulationStatus,
} from '../../hooks';
import { mapStatusActions } from '../../utils';

export const PopoverActions = () => {
  const { data: simulationStatus } = useSimulationStatus();
  const sandboxUiContext = useSandboxUiContext();
  const { form, hasForm, currentFormConfig } = useSimulationFormContext();
  const rerenderCta = sandboxUiContext?.rerenderCta as () => Promise<void>;
  const updateFundingStep = useFundingStep();
  const invalidateSimulationStatus = useInvalidateSimulationStatus();
  const validActions = simulationStatus?.valid_actions as STATUS_ACTIONS[];

  const isFormValid = () => {
    if (!hasForm) return true;
    return !form.validate().hasErrors;
  };

  const handleFundingStep = (action: STATUS_ACTIONS) => {
    if (!isFormValid()) return;

    const isActionAllowed = currentFormConfig?.availableActions.includes(action);

    const payload = {
      action,
      ...(isActionAllowed ? form.getTransformedValues() : {}),
    };

    updateFundingStep.mutate(payload, {
      onSuccess: async () => {
        await invalidateSimulationStatus();
        await rerenderCta();
      },
      onError: (error) => {
        console.error('Failed to update simulation state', error);
      },
    });
  };

  // TODO: remove when BE fixes
  const sortedActions = validActions
    .map((action) => ({ ...mapStatusActions(action), key: action }))
    .sort((a, b) => Number(b.buttonVariant === 'primary') - Number(a.buttonVariant === 'primary'));

  return (
    <Flex direction="column" bg="white" mt="auto" gap="sm">
      {sortedActions.map(({ label, buttonVariant, key }) => (
        <Button key={key} onClick={() => handleFundingStep(key)} variant={buttonVariant}>
          {label}
        </Button>
      ))}
    </Flex>
  );
};
